import React from 'react';
import { motion } from 'framer-motion';
import { AlertIcon } from './Icons';
export function PainSection() {
  return <section id="pain" className="relative w-full bg-bg-primary py-20 sm:py-28 overflow-hidden" aria-label="The problem with kibble" data-id="element-285">
      {/* Subtle top gradient */}
      <div className="absolute top-0 left-0 right-0 h-32 pointer-events-none" style={{
      background: 'linear-gradient(to bottom, #0a0f0a, transparent)'
    }} aria-hidden="true" data-id="element-286" />

      <div className="max-w-3xl mx-auto px-5 sm:px-8" data-id="element-287">
        {/* Opening — dramatic, line-by-line */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="mb-16" data-id="element-288">
          <p className="font-serif text-xl sm:text-2xl md:text-3xl text-cream/90 leading-relaxed" data-id="element-289">
            You see it every day.
          </p>
          <p className="font-serif text-xl sm:text-2xl md:text-3xl text-cream/70 leading-relaxed mt-4" data-id="element-290">
            The slightly slower walk.
          </p>
          <p className="font-serif text-xl sm:text-2xl md:text-3xl text-cream/70 leading-relaxed mt-4" data-id="element-291">
            The duller coat.
          </p>
          <p className="font-serif text-xl sm:text-2xl md:text-3xl text-cream/70 leading-relaxed mt-4" data-id="element-292">
            The constant scratching.
          </p>
        </motion.div>

        {/* Paragraph — the brainwashing */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="mb-16" data-id="element-293">
          <p className="font-sans text-base sm:text-lg text-cream-muted leading-relaxed" data-id="element-294">
            We've been brainwashed to believe that a brown bag of processed
            starch is "enough." It's not.
          </p>
        </motion.div>

        {/* Stat callout — cancer */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="relative my-16 py-10 px-6 sm:px-10 border-l-4 border-gold bg-bg-card/50 rounded-r-lg" data-id="element-295">
          <AlertIcon className="w-6 h-6 text-urgency-red-bright mb-4" data-id="element-296" />
          <p className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-gold leading-tight" data-id="element-297">
            1 in 2 dogs will develop cancer.
          </p>
          <p className="font-sans text-base sm:text-lg text-cream-muted mt-3" data-id="element-298">
            In the U.S. today. For large breeds, the odds are even worse.
          </p>
        </motion.div>

        {/* Comparison image */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="my-16 rounded-lg overflow-hidden border border-white/5" data-id="element-299">
          <img src="https://cdn.magicpatterns.com/uploads/1aKYbVsamSDgTJcKWLLE3t/image_3-1.png" alt="Comparison: processed kibble in a dark warehouse versus a bowl of fresh broccoli, sardines, blueberries, and egg yolk in warm sunlight" className="w-full h-auto" data-id="element-300" />
          <div className="flex" data-id="element-301">
            <div className="flex-1 bg-gray-900/80 py-3 px-4 text-center" data-id="element-302">
              <p className="font-sans text-xs sm:text-sm text-cream-muted uppercase tracking-wider" data-id="element-303">
                What they sell you
              </p>
            </div>
            <div className="flex-1 bg-green-deep/40 py-3 px-4 text-center" data-id="element-304">
              <p className="font-sans text-xs sm:text-sm text-gold uppercase tracking-wider" data-id="element-305">
                What your dog needs
              </p>
            </div>
          </div>
        </motion.div>

        {/* Stat callout — senior by 6 */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="relative my-16 py-10 px-6 sm:px-10 border-l-4 border-urgency-red bg-bg-card/50 rounded-r-lg" data-id="element-306">
          <p className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-cream leading-tight" data-id="element-307">
            Most giants are considered{' '}
            <span className="text-urgency-red-bright" data-id="element-308">"senior"</span> by age 6.
          </p>
          <p className="font-sans text-base sm:text-lg text-cream-muted mt-3" data-id="element-309">
            Cane Corsos. Mastiffs. Great Danes. Their clocks are ticking faster
            than you think.
          </p>
        </motion.div>

        {/* Closing — the tragedy */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="text-center mt-16" data-id="element-310">
          <p className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-cream leading-tight" data-id="element-311">
            That is a tragedy.
          </p>
          <p className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-gold mt-3" data-id="element-312">
            And it is avoidable.
          </p>
        </motion.div>
      </div>
    </section>;
}